import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { ServerResponseBudgetHistory } from 'models/BudgetHistory';

import { WidgetContainer } from 'components';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { useStyles } from './style';
import ExpensesWidgetContent from 'shared/components/ExpensesWidgetContent';
import getBudgetHistory from './helpers/getBudgetHistory';

interface Props {
  budget: ServerResponseBudgetHistory;
}

const CooperativeBudgetWidget: React.FC<Props> = ({ budget }) => {
  const history = useHistory();
  const classes = useStyles();

  const forwardToCooperativeBudget = () => {
    history.push('/financial-information?tab=cooperative-budgets');
  };

  const budgetHistory = getBudgetHistory(budget);

  return (
    <WidgetContainer
      themeColor="darkBlue"
      title={'Kaikki taloustiedot'}
      action={forwardToCooperativeBudget}
    >
      <Box padding="15px">
        <h3 className={classes.title}>Talous</h3>
      </Box>
      <Stack
        flexDirection="column"
        justifyContent="center"
        padding="15px"
        paddingTop={0}
        height="100%"
        spacing={2}
      >
        <ExpensesWidgetContent budgetHistory={budgetHistory} />
      </Stack>
    </WidgetContainer>
  );
};

export default memo(CooperativeBudgetWidget);
